import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { OrderLog } from '../../../../../../models/orderModel';

@Component({
  selector: 'app-back-office24-order-log-details',
  templateUrl: './back-office24-order-log-details.component.html',
  styleUrl: './back-office24-order-log-details.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BackOffice24OrderLogDetailsComponent implements OnInit, OnDestroy {
  componentDestroyed$: Subject<boolean> = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) public orderLog: OrderLog,
  ) { }

  ngOnInit(): void { }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}